<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Reportes - Data Torneo" />

    <Report />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Report from "@/components/Pages/Admin/Reports/tournament-player-data.vue";

export default defineComponent({
  name: "ReportTournamentPlayerDataPage",
  components: {
    PageTitle,
    Report,
  },
});
</script>








